import React from 'react';
import { useTranslation } from 'react-i18next';

const StatsSection = () => {
  const { t } = useTranslation('latvia');

  const stats = [
    {
      number: t('stats.1.number'),
      label: t('stats.1.label'),
      icon: 'ri-team-line',
    },
    {
      number: t('stats.2.number'),
      label: t('stats.2.label'),
      icon: 'ri-trophy-line',
    },
    {
      number: t('stats.3.number'),
      label: t('stats.3.label'),
      icon: 'ri-time-line',
    },
    {
      number: t('stats.4.number'),
      label: t('stats.4.label'),
      icon: 'ri-medal-line',
    },
  ];

  return (
    <section className="py-6 md:py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gold-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-5 md:mb-16">
          <h2 className="text-xl md:text-5xl font-bold mb-1.5 md:mb-4 font-serif">
            {t('stats.title')}
          </h2>
          <p className="text-[11px] md:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            {t('stats.description')}
          </p>
        </div>

        <div className="grid grid-cols-4 md:grid-cols-4 gap-2 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-9 h-9 md:w-20 md:h-20 flex items-center justify-center bg-gold-500/20 rounded-full mb-1.5 md:mb-4 mx-auto">
                <i className={`${stat.icon} text-base md:text-4xl text-gold-400`}></i>
              </div>
              <div className="text-lg md:text-5xl font-bold text-gold-400 mb-0.5 md:mb-2 font-serif leading-tight">
                {stat.number}
              </div>
              <div className="text-gray-300 text-[9px] md:text-sm leading-tight">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-5 md:mt-16 bg-white/5 backdrop-blur-sm rounded-lg md:rounded-2xl p-3 md:p-8 border border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2.5 md:gap-6">
            <div className="flex items-center">
              <div className="w-9 h-9 md:w-16 md:h-16 flex items-center justify-center bg-gold-500/20 rounded-full mr-2.5 md:mr-4 flex-shrink-0">
                <i className="ri-store-2-line text-base md:text-3xl text-gold-400"></i>
              </div>
              <div>
                <h3 className="text-[11px] md:text-2xl font-bold mb-0 md:mb-1 leading-snug">
                  {t('stats.asian.title')}
                </h3>
                <p className="text-gray-300 text-[10px] md:text-sm">
                  {t('stats.asian.location')}
                </p>
              </div>
            </div>
            <div className="text-center md:text-right">
              <div className="text-base md:text-3xl font-bold text-gold-400 mb-0 md:mb-1">
                &euro;500K+
              </div>
              <div className="text-gray-300 text-[10px] md:text-sm">{t('stats.asian.revenue')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;